import type { AutarkyStateType } from '@/api/homeV2Status/types';

import { namespace } from 'vuex-class';
import { UpgradeStateEnum } from '@/enums/autarkyUpgrade';
import { upgradeUserInfosKey, UpgradeUserInfoType } from '@/constant/user';
import { Notify } from 'vant';
import { Vue, Component } from 'vue-property-decorator';
import type { StateType } from '../types';
import { AUTARKY_UPGRADE_PROCESS_STATE } from '../const';

const HomeStore = namespace('home');


// TODO: 老户升级状态收拢和抽离
@Component
export default class Autarkey extends Vue {
    // 导出homeStore中的autarkyState
    @HomeStore.State autarkyState!: AutarkyStateType;

    @HomeStore.State creditData!: StateType['creditData'];

    // 返回当前自营用户状态
    protected get autarkyStateType(): UpgradeStateEnum | undefined {
      if (this.autarkyState && this.autarkyState.autarkyUpgradeState) {
        return this.autarkyState.autarkyUpgradeState;
      }
      return undefined;
    }

    // 是否是自营升级用户 - 包含初始化用户及升级中用户
    protected get isUpgradeProcessing():boolean {
      if (this.autarkyStateType) {
        const { autarky, autarkyUpgradeState } = this.autarkyState;
        return autarky && AUTARKY_UPGRADE_PROCESS_STATE.includes(autarkyUpgradeState);
      }
      return false;
    }

    /** 是否是自营升级用户且有成功授信记录 */
    protected get isUpgradeProcessingAndCredited():boolean {
      return Boolean(this.isUpgradeProcessing
        && this.creditData
        && this.creditData.creditStatus
        && !this.creditData.preCredit);
    }

    // 是否升级中
    protected get isUpgradeSubmit():boolean {
      return this.autarkyState && this.autarkyState.autarkyUpgradeState === UpgradeStateEnum.SUBMIT;
    }

    // 是否是自营升级成功用户
    protected get isUpgradeSucceed():boolean {
      if (this.autarkyStateType) {
        const { autarky, autarkyUpgradeState } = this.autarkyState;
        return autarky && (autarkyUpgradeState === UpgradeStateEnum.SUCCEEDED);
      }
      return false;
    }

    // 自营升级用户 Tost 提示升级结果
    protected showAutarkeyUpgradeTost():void {
      if (this.isUpgradeSucceed) {
        const { autarkyUpgradeState } = this.autarkyState;
        const upgradeUserInfo = JSON.parse(localStorage.getItem(upgradeUserInfosKey) || '{}') as UpgradeUserInfoType;
        if (upgradeUserInfo.needToast) {
          localStorage.setItem(upgradeUserInfosKey, JSON.stringify({
            // 一次性弹框，弹过后续就不需要再弹
            needToast: false,
          }));
          // 仅仅成功时提示
          if (autarkyUpgradeState === UpgradeStateEnum.SUCCEEDED) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            Notify('恭喜完成升级，新额度已可以使用!');
          }
        }
      }
    }
}
